/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import { AuthService } from '../services/AuthServices';

class SignIn extends React.Component {
    constructor(props: any) {
        super(props);
        new AuthService().login();
    }
    render() {
        return false;
    }
}

export default SignIn;
